/* =====================================================================
   UUGI People Page — people.js
   ===================================================================== */

$(function () {

  /* ---- Navbar scroll state ---- */
  var $nav = $('#nav');
  function onScroll() {
    $nav.toggleClass('is-scrolled', $(window).scrollTop() > 30);
  }
  $(window).on('scroll', onScroll);
  onScroll();

  /* ---- Burger menu: see js/nav.js ---- */

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -36px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ---- Filter tabs ---- */
  // Roles come from the back office (Contribution Role Group) and are rendered
  // into data-filter / data-role by the Razor view. A person can hold several
  // roles, so data-role is a comma-separated list of slugs — never hard-code
  // role names here; split the list and tally each role from the rendered cards.
  var $filters = $('.ppl-filter');
  if ($filters.length) {
    function rolesOf(el) {
      return ($(el).attr('data-role') || '').split(',')
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length; });
    }

    var counts = {}, total = 0;
    $('.ppl-con-card').each(function () {
      total++;
      rolesOf(this).forEach(function (r) { counts[r] = (counts[r] || 0) + 1; });
    });
    $filters.each(function () {
      var f = ($(this).attr('data-filter') || '').trim();
      $(this).find('.ppl-filter__count').text(f === 'all' ? total : (counts[f] || 0));
    });

    function filterGrid(role) {
      var $cards = $('.ppl-con-card');

      // Fade all out
      $cards.addClass('is-fading');

      setTimeout(function () {
        // Show/hide via inline display:none — `.ppl-con-card{display:flex}` defeats [hidden].
        $cards.each(function () {
          var match = role === 'all' || rolesOf(this).indexOf(role) !== -1;
          $(this).css('display', match ? '' : 'none').removeClass('is-fading');
        });
        // Snap visible to invisible state, then transition in
        var $visible = $cards.filter(':visible');
        $visible.addClass('is-fadein');
        setTimeout(function () {
          $visible.removeClass('is-fadein');
        }, 40);
      }, 260);
    }

    $filters.on('click', function () {
      if ($(this).hasClass('is-active')) return;
      $filters.removeClass('is-active').attr('aria-selected', 'false');
      $(this).addClass('is-active').attr('aria-selected', 'true');
      filterGrid(($(this).attr('data-filter') || '').trim());
    });
  }

  /* ---- Smooth anchor scroll ---- */
  $('a[href^="#"]').on('click', function (e) {
    var t = $(this).attr('href');
    if (!t || t.length < 2) return;
    var $tgt = $(t);
    if (!$tgt.length) return;
    e.preventDefault();
    $('html, body').animate({ scrollTop: $tgt.offset().top - 70 }, 680, 'swing');
  });

});
